// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__3E8-Y","large":"styles_large__1557g"};